import type * as React from "react";
import { cn } from "../utils/mergeClassNames";

interface IHStackProps extends React.HTMLAttributes<HTMLDivElement> {
  ref?: React.RefObject<HTMLDivElement>;
  className?: string;
  children: React.ReactNode;
}

const HStack = ({ className, ...props }: IHStackProps) => {
  return (
    <div
      className={cn("flex flex-row", className)}
      {...props}
    />
  );
};
HStack.displayName = "HStack";

export { HStack };
